import { render, staticRenderFns } from "./ProfileSideBar.vue?vue&type=template&id=84f22ac6&scoped=true&"
import script from "./ProfileSideBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProfileSideBar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProfileSideBar.vue?vue&type=style&index=0&id=84f22ac6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f22ac6",
  null
  
)

export default component.exports